import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Badge } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { languages } from 'app/config/translation';
import { getUser } from './user.reducer';
import { IRootState } from 'app/shared/reducers';

export interface IUserManagementDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ login: string }> {}

export class UserManagementDetail extends React.Component<IUserManagementDetailProps> {
  componentDidMount() {
    this.props.getUser(this.props.account.login);
  }

  render() {
    const { user } = this.props;
    let emailVerified;
    let email;
    let phoneVerified;
    let phone;
    if (user.emails && user.emails.length) {
      const emailsArr = user.emails;
      Object.keys(emailsArr).forEach((key, index) => {
        if (emailsArr[key].type && emailsArr[key].type === 'emailVerified') {
          emailVerified = emailsArr[key].value;
        } else {
          email = emailsArr[key];
        }
      });
    }
    if (user.phoneNumbers && user.phoneNumbers.length) {
      const phoneArr = user.phoneNumbers;
      Object.keys(phoneArr).forEach((key, index) => {
        if (phoneArr[key].type && phoneArr[key].type === 'phoneVerified') {
          phoneVerified = phoneArr[key].value;
        } else {
          phone = phoneArr[key];
        }
      });
    }
    return (
      <div>
        <h2>
          <Translate contentKey="userManagement.detail.title">User</Translate> [<b>{user.userName}</b>]
        </h2>
        <Row size="md">
          <dl className="jh-entity-details">
            <dt>
              <Translate contentKey="userManagement.login">Login</Translate>
            </dt>
            <dd>
              <span>{user.userName}</span>&nbsp;
            </dd>
            <dt>
              <Translate contentKey="userManagement.firstName">First Name</Translate>
            </dt>
            <dd>{user.name ? user.name.givenName : null}</dd>
            <dt>
              <Translate contentKey="userManagement.lastName">Last Name</Translate>
            </dt>
            <dd>{user.name ? user.name.familyName : null}</dd>
            <dt>
              <Translate contentKey="userManagement.email">Email</Translate>
            </dt>
            {email || emailVerified ? (
              emailVerified ? (
                <dd>
                  <span>{emailVerified}</span>&nbsp;
                  <Badge color="success">
                    <Translate contentKey="userManagement.verified">Verified</Translate>
                  </Badge>
                </dd>
              ) : (
                <dd>
                  {email} &nbsp;
                  <Badge color="danger">
                    <Translate contentKey="userManagement.notVerified">Not Verified</Translate>
                  </Badge>
                </dd>
              )
            ) : null}

            <dt>
              <Translate contentKey="userManagement.mobile">Phone Number</Translate>
            </dt>
            {phone || phoneVerified ? (
              phoneVerified ? (
                <dd>
                  <span>{phoneVerified}</span>&nbsp;
                  <Badge color="success">
                    <Translate contentKey="userManagement.verified">Verified</Translate>
                  </Badge>
                </dd>
              ) : (
                <dd>
                  {phone} &nbsp;
                  <Badge color="danger">
                    <Translate contentKey="userManagement.notVerified">Not Verified</Translate>
                  </Badge>
                </dd>
              )
            ) : null}
            <dt>
              <Translate contentKey="userManagement.createdDate">Created Date</Translate>
            </dt>
            <dd>
              <TextFormat value={user.meta ? user.meta.created : null} type="date" format={APP_DATE_FORMAT} blankOnInvalid />
            </dd>
            <dt>
              <Translate contentKey="userManagement.lastModifiedDate">Last Modified Date</Translate>
            </dt>
            <dd>
              <TextFormat value={user.meta ? user.meta.lastModified : null} type="date" format={APP_DATE_FORMAT} blankOnInvalid />
            </dd>
            {/* <dt>
              <Translate contentKey="userManagement.profiles">Profiles</Translate>
            </dt> */}
            {/* <dd>
              <ul className="list-unstyled">
                {user.roles
                  ? user.roles.map((authority, i) => (
                      <li key={`user-auth-${i}`}>
                        <Badge color="info">{authority.value}</Badge>
                      </li>
                    ))
                  : null}
              </ul>
            </dd> */}
          </dl>
        </Row>
        <Button tag={Link} to="/" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  user: storeState.userManagement.userInfo,
  account: storeState.authentication.account
});

const mapDispatchToProps = { getUser };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagementDetail);
